// lib
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Navigate } from "react-big-calendar";
import TimeGrid from "react-big-calendar/lib/TimeGrid";
// src
import { formats } from "i18n/localizer";

const RANGE_LENGTH = 3;

const ThreeDays = (props) => {
  const { date } = props;
  const range = ThreeDays.range(date);

  return <TimeGrid {...props} range={range} />;
};

ThreeDays.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

ThreeDays.range = (start) => {
  const end = moment(start).add(RANGE_LENGTH - 1, "d");

  let current = start;
  const range = [];

  while (moment(current).isSameOrBefore(end)) {
    range.push(current);
    current = moment(current).add(1, "d").toDate();
  }

  return range;
};

ThreeDays.navigate = (date, action) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return moment(date).add(-RANGE_LENGTH, "d").toDate();

    case Navigate.NEXT:
      return moment(date).add(RANGE_LENGTH, "d").toDate();

    default:
      return date;
  }
};

ThreeDays.title = (date) =>
  `${formats().dayRangeHeaderFormat({ start: date, end: moment(date).add(3, "day") })}`;

export default ThreeDays;
